import { Box, Typography } from "@mui/material"
import React from "react"

export const Dashboard = React.memo(() => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      width: "100%",
      animation: "fadeIn 600ms"
    }}>
    <Typography color="textSecondary" sx={{ mt: "2rem" }}>
      Dashborad PAGE
    </Typography>
  </Box>
))
